import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTemplate } from 'API/Templates/updateTemplate';
import { uploadTemplateImage } from 'API/Templates/uploadTemplateImage';

const useUpdateTemplate = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async ({ newImage, ...templateData }) => {
        const response = await updateTemplate(templateData);
        if (newImage) {
            await uploadTemplateImage(templateData.id, newImage);
        }
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['Templates'] });
            queryClient.invalidateQueries({
                queryKey: ['Template', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateTemplate;
